"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricsReviewDrawer = void 0;
var react_1 = __importStar(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var MERGE_TOOLTIP = 'Confirm the two are the same concept. The new element is discarded, and any place in a use case that referred to it now points to the existing canonical element. Result: one bubble, one popup, combined mention count.';
var KEEP_SEPARATE_TOOLTIP = 'Treat the two as genuinely different concepts. Both elements survive as separate rows with their own popup, label, and mention count.';
var EDIT_MERGE_TOOLTIP = 'Rename the existing canonical element first (so the popup label becomes the wording you prefer), then merge as above.';
var InfoIcon = function (_a) {
    var tooltip = _a.tooltip;
    return (react_1.default.createElement(office_ui_fabric_react_1.TooltipHost, { content: tooltip, directionalHint: office_ui_fabric_react_1.DirectionalHint.topCenter, calloutProps: { gapSpace: 4 } },
        react_1.default.createElement(office_ui_fabric_react_1.IconButton, { iconProps: { iconName: 'Info' }, ariaLabel: "What does this do?", styles: { root: { height: 24, width: 24 } } })));
};
/**
 * Right-hand drawer that lists pending element-merge candidates
 * proposed by the extraction cascade. Each row offers three actions:
 *
 *   1. **Merge**       — confirm the candidate and re-point mentions.
 *   2. **Keep separate** — reject the merge; both elements survive.
 *   3. **Edit & merge**  — patch the candidate then merge.
 *
 * The component is intentionally action-only: it surfaces the
 * minimum payload needed for triage and delegates persistence to
 * the parent via the `on*` callbacks.
 */
exports.MetricsReviewDrawer = function (_a) {
    var isOpen = _a.isOpen, onDismiss = _a.onDismiss, items = _a.items, isLoading = _a.isLoading, error = _a.error, onApprove = _a.onApprove, onReject = _a.onReject, onEdit = _a.onEdit;
    var _b = react_1.useState(null), busyId = _b[0], setBusyId = _b[1];
    var _c = react_1.useState(null), editState = _c[0], setEditState = _c[1];
    var runWithBusy = function (id, action) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setBusyId(id);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, action()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setBusyId(null);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(office_ui_fabric_react_1.Panel, { isOpen: isOpen, onDismiss: onDismiss, type: office_ui_fabric_react_1.PanelType.medium, headerText: "Pending review (" + items.length + ")", isLightDismiss: true, closeButtonAriaLabel: "Close review queue" },
        isLoading && react_1.default.createElement(office_ui_fabric_react_1.Spinner, { size: office_ui_fabric_react_1.SpinnerSize.medium, label: "Loading review queue\u2026" }),
        error && (react_1.default.createElement("div", { style: { color: '#a4262c', marginBottom: 12 } },
            "Failed to load reviews: ",
            error)),
        !isLoading && items.length === 0 && (react_1.default.createElement("div", { style: { marginTop: 24, color: '#605e5c' } }, "Nothing to review right now. New extractions will queue here for confirmation.")),
        items.map(function (item) {
            var isBusy = busyId === item.id;
            var isEditing = editState !== null && editState.reviewId === item.id;
            var activeEdit = isEditing ? editState : null;
            return (react_1.default.createElement("div", { key: item.id, style: {
                    padding: '12px 0',
                    borderBottom: '1px solid #edebe9',
                    opacity: isBusy ? 0.6 : 1,
                } },
                react_1.default.createElement("div", { style: { fontSize: 12, color: '#605e5c', marginBottom: 4 } },
                    "Review #",
                    item.id,
                    " \u00B7 type ",
                    item.candidate.type,
                    " \u00B7 similarity",
                    ' ',
                    item.similarity.toFixed(3)),
                react_1.default.createElement("div", { style: { marginBottom: 8 } },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("strong", null, "New:"),
                        " ",
                        item.newElement.canonicalName,
                        ' ',
                        react_1.default.createElement("span", { style: { color: '#605e5c' } },
                            "(",
                            item.newElement.id,
                            ")")),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("strong", null, "Existing candidate:"),
                        " ",
                        item.candidate.canonicalName,
                        ' ',
                        react_1.default.createElement("span", { style: { color: '#605e5c' } },
                            "(",
                            item.candidate.id,
                            ")"))),
                isEditing && activeEdit && (react_1.default.createElement("div", { style: { marginBottom: 8 } },
                    react_1.default.createElement(office_ui_fabric_react_1.TextField, { label: "Canonical name", value: activeEdit.canonicalName, onChange: function (_, value) {
                            return setEditState(__assign(__assign({}, activeEdit), { canonicalName: value || '' }));
                        } }),
                    react_1.default.createElement(office_ui_fabric_react_1.TextField, { label: "Description", value: activeEdit.description, multiline: true, rows: 3, onChange: function (_, value) { return setEditState(__assign(__assign({}, activeEdit), { description: value || '' })); } }))),
                react_1.default.createElement("div", { style: { display: 'flex', gap: 8, flexWrap: 'wrap' } },
                    !isEditing ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(InfoIcon, { tooltip: MERGE_TOOLTIP }),
                        react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { text: "Merge", disabled: isBusy, onClick: function () { return void runWithBusy(item.id, function () { return onApprove(item.id); }); } }),
                        react_1.default.createElement(InfoIcon, { tooltip: KEEP_SEPARATE_TOOLTIP }),
                        react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { text: "Keep separate", disabled: isBusy, onClick: function () { return void runWithBusy(item.id, function () { return onReject(item.id); }); } }),
                        react_1.default.createElement(InfoIcon, { tooltip: EDIT_MERGE_TOOLTIP }),
                        react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { text: "Edit & merge", iconProps: { iconName: 'Edit' }, disabled: isBusy, onClick: function () {
                                return setEditState({
                                    reviewId: item.id,
                                    canonicalName: item.candidate.canonicalName,
                                    description: '',
                                });
                            } }))) : activeEdit ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { text: "Save edits & merge", disabled: isBusy || !activeEdit.canonicalName.trim(), onClick: function () {
                                return void runWithBusy(item.id, function () { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, onEdit(item.id, {
                                                    edits: {
                                                        canonicalName: activeEdit.canonicalName.trim(),
                                                        description: activeEdit.description.trim() || undefined,
                                                    },
                                                })];
                                            case 1:
                                                _a.sent();
                                                setEditState(null);
                                                return [2 /*return*/];
                                        }
                                    });
                                }); });
                            } }),
                        react_1.default.createElement(office_ui_fabric_react_1.DefaultButton, { text: "Cancel", onClick: function () { return setEditState(null); } }))) : null,
                    isBusy && react_1.default.createElement(office_ui_fabric_react_1.Spinner, { size: office_ui_fabric_react_1.SpinnerSize.small }))));
        }),
        react_1.default.createElement("div", { style: { marginTop: 16, textAlign: 'right' } },
            react_1.default.createElement(office_ui_fabric_react_1.IconButton, { iconProps: { iconName: 'Cancel' }, onClick: onDismiss }))));
};
